export default "__VITE_ASSET__DGEN7pNN__"